import ListingPage from '../../components/ListingPage';
import ProductFeedsCards from '../../components/ProductFeeds/ProductFeedsCards';

const ProductFeedsPage = () => {
  return (
    <ListingPage
      createRestrictionKey="productFeedsCreate"
      entityType="productFeed"
      useStats={true}
      filterBy="name"
      Cards={ProductFeedsCards}
    />
  );
};

export default ProductFeedsPage;
